<!-- <kendo-window
*ngIf="_active"
title="Documents"
(close)="_closeDocumentsWindow()"
class="addFromLibrary"
>
<kendo-grid [data]="gridData" [pageSize]="10" [height]="400">
  <kendo-grid-column field="name" title="File Name" width="150"></kendo-grid-column>
  <kendo-grid-column field="thumbnail" title="Document">
    <ng-template kendoGridCellTemplate let-dataItem>
      <a
        (click)="downloadFile(_storagePath + dataItem['stream'], dataItem.name)"
        title="{{ dataItem.name }}"
        width="50"
        >
        <img
          class="sub-menu--icon"
          [src]="'/assets/menu/' + _theme + '/documentDownload-icon.svg'"
          />
        </a>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="size" title="Size"></kendo-grid-column>
  </kendo-grid>
</kendo-window> -->
@if (_active) {
  <kendo-window
    title="Documents"
    (close)="_closeDocumentsWindow()"
    class="addFromLibrary"
    >
    <div class="greytabtop">
    </div>
    @if (_documentsGridColumns) {
      <asap-grid-layout
        [page]="_page"
        [entityName]="'Documents'"
        [sortingEnabled]="true"
        [enableSiteSelection]="false"
        [resolver]="_getFiles"
        class="ListGrid"
        [selectable]="false"
        [singleSelect]="true"
        [pagingEnabled]="true"
        [filteringEnable]="true"
        [addNewFormEnabled]="false"
        [deletedEnabled]="false"
        [DisableDestory]="false"
        [orderEnable]="true"
        [headerEnable]="true"
        [enableSiteSelection]="false"
        >
        @for (column of _documentsGridColumns; track column) {
          @if (column.selected) {
            @if (!column.isTemplate) {
              <ng-template
                pageListColumn
                [field]="column.field"
                [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                [type]="column.type"
                let-item
                >
                @if (column.type == 'date') {
                  {{ item[column.field] | dateFormat }}
                }
                @if (column.type != 'date') {
                  {{item[column.field]}}
                }
                <!-- {{item[column.field]}} -->
              </ng-template>
            }
            @if (column.isTemplate) {
              <ng-template
                pageListColumn
                [field]="column.field"
                [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                [type]="column.type"
                let-item
                ><!--
                [href]="_storagePath + item['stream']"
                [download]="item.name" -->
                @if (column.field == 'documentPath') {
                  <a
                    (click)="downloadFile(_storagePath + item['stream'], item.name)"
                    title="{{ item.name }}"
                    width="50"
                  ><img  class="sub-menu--icon" [src]="'/assets/menu/'+ _theme +'/documentDownload-icon.svg'" /></a>
                }
                @if (column.field == 'fileSource.name') {
                  {{item.fileSource?.name}}
                }
                @if (column.field == 'size') {
                  {{setFileSize(item.size)}} KB
                }
                @if (column.type == 'date') {
                  {{ item[column.field] | dateFormat }}
                }
                @if (column.field == 'account') {
                  {{getAccountsString(item.fileAccounts)}}
                }
              </ng-template>
            }
          }
        }
      </asap-grid-layout>
    }
  </kendo-window>
}
